import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { ChatMessageBubbleContext } from "./ChatMessageBubbleContext";

export const useChatMessageBubble = () => {
  const context = useContext(ChatMessageBubbleContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useChatMessageBubble",
      "ChatMessageBubbleContext"
    );
  }

  return context;
};
